import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { Header } from '../components/shared/Header';
import { EmptyState } from '../components/shared/EmptyState';
import { Button } from '../components/ui/button';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header title="Dividy" showLogo />
      <main className="p-4">
        <EmptyState
          icon={<SearchX className="h-12 w-12" />}
          title="Página no encontrada"
          description="La página que buscas no existe o ha sido movida"
          action={
            <Button asChild>
              <Link to="/">Ir al inicio</Link>
            </Button>
          }
        />
      </main>
    </div>
  );
}
